/* eslint-disable no-param-reassign */
function setActiveToggle(
  activeButton: HTMLButtonElement,
  inactiveButton: HTMLButtonElement,
  showContent: HTMLElement,
  hideContent: HTMLElement,
): void {
  activeButton.classList.add('active');
  inactiveButton.classList.remove('active');

  activeButton.style.color = '#598fe2';
  activeButton.style.borderBottom = '2px solid #598fe2';

  inactiveButton.style.color = 'black';
  inactiveButton.style.borderBottom = 'none';

  const recruiterIconPath = document.querySelector('.recruiter-icon path') as SVGPathElement;
  const candidateIconPath = document.querySelector('.candidate-icon path') as SVGPathElement;

  if (recruiterIconPath && candidateIconPath) {
    if (activeButton.id === 'recruiter-toggle') {
      recruiterIconPath.setAttribute('fill', '#4A90E2');
      candidateIconPath.setAttribute('fill', '#000');
    } else {
      recruiterIconPath.setAttribute('fill', '#000');
      candidateIconPath.setAttribute('fill', '#4a90e2');
    }
  }

  showContent.style.display = 'block';
  hideContent.style.display = 'none';
}

function initHandicapToggle(): void {
  const recruiterToggle = document.querySelector('#recruiter-toggle') as HTMLButtonElement;
  const candidateToggle = document.querySelector('#candidate-toggle') as HTMLButtonElement;
  const recruiterContent = document.querySelector('#recruiter-content') as HTMLElement;
  const candidateContent = document.querySelector('#candidate-content') as HTMLElement;

  if (!recruiterToggle || !candidateToggle || !recruiterContent || !candidateContent) {
    return;
  }

  recruiterToggle.addEventListener('click', () => {
    setActiveToggle(
      recruiterToggle,
      candidateToggle,
      recruiterContent,
      candidateContent,
    );
  });

  candidateToggle.addEventListener('click', () => {
    setActiveToggle(
      candidateToggle,
      recruiterToggle,
      candidateContent,
      recruiterContent,
    );
  });
}

document.addEventListener('DOMContentLoaded', initHandicapToggle);
